import React, { useEffect } from "react"
import { Button } from "../components/common/button/Button"
import { validatePostcode } from "./validation-utils"
import { getClosestDealerships, getLatitudeAndLongitude } from "./geoLocation-utils"

const MINIMUM_POSTCODE_LENGTH = 5

interface GeoLocationProps {
  postCode: string
  setLocation?: (props: any) => void
  setPostCodeError: (props: any) => void
  groupId: string
  addClosestDealerships: Function
  closestDealerships?: any[]
  setButtonClicked?: (props: any) => void
  dealershipCtaDisabled: boolean
  setDealershipCtaDisabled(value: boolean): void
  rendersFindDealershipCta: boolean
  validPostcode: boolean
  buttonType?: "button" | "submit" | undefined
  buttonId?: string
  setFindMyDealershipClicked?: (value: boolean) => void
  variant?: "blue" | "white" | "inverted-blue" | "clear"
  brand?: string
}

const GeoLocation: React.FC<GeoLocationProps> = ({
  postCode,
  setLocation,
  setPostCodeError,
  addClosestDealerships,
  closestDealerships,
  groupId,
  setButtonClicked,
  dealershipCtaDisabled,
  setDealershipCtaDisabled,
  rendersFindDealershipCta,
  validPostcode,
  buttonType,
  buttonId,
  setFindMyDealershipClicked,
  variant,
  brand
}) => {
  useEffect(() => {
    if (postCode && postCode.length >= MINIMUM_POSTCODE_LENGTH) {
      if (validatePostcode(postCode)) {
        setDealershipCtaDisabled(false)
      }
    } else {
      setDealershipCtaDisabled(true)
    }
  }, [postCode, setDealershipCtaDisabled])

  const onEnteringPostcode = async () => {
    try {
      if (postCode) {
        const [getGeoLocation]: any = await Promise.all([
          getLatitudeAndLongitude({postCode, setLocation, setPostCodeError, setButtonClicked}),
        ])

        if (!getGeoLocation) {
          setPostCodeError(true)
        } else {
          setLocation && setLocation(getGeoLocation)
          setPostCodeError(false)
        }
      } else {
        setPostCodeError(false)
        return null
      }
      return null
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (rendersFindDealershipCta === false && validPostcode === true) {
      onEnteringPostcode()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postCode])

  const onFindDealershipClick = async () => {
    try {
      if (postCode) {
        setFindMyDealershipClicked && setFindMyDealershipClicked(true)
        addClosestDealerships({
          ...closestDealerships,
          data: [],
        })
        setButtonClicked && setButtonClicked(true)
        const [getGeoLocation]: any = await Promise.all([
          getLatitudeAndLongitude({postCode, setLocation, setPostCodeError, setButtonClicked}),
        ])

        // For local dev purposes
        // const getGeoLocation = {
        //   longitude: -2.242631,
        //   latitude: 53.480759
        // }
        if (!getGeoLocation) {
          setPostCodeError(true)
          setButtonClicked && setButtonClicked(true)
        } else {
          setLocation && setLocation(getGeoLocation)
          setPostCodeError(false)
          setButtonClicked && setButtonClicked(true)

          const location = {
            longitude: getGeoLocation.longitude,
            latitude: getGeoLocation.latitude,
          }

          const dealershipArray = await getClosestDealerships(groupId, location, brand);

          if (dealershipArray) {
            addClosestDealerships({
              ...closestDealerships,
              data: dealershipArray,
            })
            return dealershipArray
          }
        }
      } else {
        setPostCodeError(false)
        setDealershipCtaDisabled(true)
        return null
      }
      return null
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <>
      {rendersFindDealershipCta ? (
        <Button
          variant={variant ? variant : "blue"}
          className="find-dealership"
          onClick={() => onFindDealershipClick()}
          disabled={dealershipCtaDisabled}
          type={buttonType}
          id={buttonId}
        >
          Find my dealership
        </Button>
      ) : (
        <></>
      )}
    </>
  )
}

export { GeoLocation }
